import { useCallback, useState } from 'react';
import type { IRecordListModel } from '@platform/core/types';
import { isComplete } from './advancedFilter';
import type { IAdvancedPanelState } from './IAdvancedPanelState';
import { quickFieldsCount } from './quickFieldFilters';
import { useAdvancedFilter } from './useAdvancedFilter';
import { useQuickFields } from './useQuickFields';

/**
 * Панель розширених фільтрів сторінки модуля: умови й швидкі поля типу запису (спільні для всіх подань модуля); будь-яка зміна повертає
 * список на першу сторінку; відкритість панелі — стан сторінки (за замовчуванням закрита).
 */
export function useAdvancedPanel(model: IRecordListModel): IAdvancedPanelState {
  const [conditions, setConditions] = useAdvancedFilter(model.ws, model.rt.key);
  const [quick, setQuick] = useQuickFields(model.ws, model.rt.key);
  const [open, setOpen] = useState(false);
  const { setState, state } = model;
  const firstPage = useCallback(() => { if (state.page !== 1) setState({ page: 1 }); }, [setState, state.page]);
  const change = useCallback((next: typeof conditions) => { setConditions(next); firstPage(); }, [setConditions, firstPage]);
  const changeQuick = useCallback((next: typeof quick) => { setQuick(next); firstPage(); }, [setQuick, firstPage]);
  const clearAll = useCallback(() => { setConditions([]); setQuick({}); firstPage(); }, [setConditions, setQuick, firstPage]);
  const toggle = useCallback(() => setOpen((o) => !o), []);
  const close = useCallback(() => setOpen(false), []);
  return { conditions, quick, applied: conditions.filter(isComplete).length + quickFieldsCount(quick), change, changeQuick, clearAll, open, toggle, close };
}
